import { render } from "./Toaster.vue?vue&type=template&id=ef0dbcf8&scoped=true"
import script from "./Toaster.vue?vue&type=script&lang=js"
export * from "./Toaster.vue?vue&type=script&lang=js"

import "./Toaster.vue?vue&type=style&index=0&id=ef0dbcf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0dbcf8"]])

export default __exports__